import { Contact } from '@repo/types';
import ContactListItem from './ContactListItem';
import { ContactsListFormData } from './contracts';
import { useContactsQuery } from '@data/contacts/useContactsQuery';
import { useMemo } from 'react';
import { SkeletonLoader } from '@ui/common/components/SkeletonLoader';

export type ContactsListProps = ContactsListFormData;

export default function ContactsList(props: ContactsListProps) {
  const { data: fetchedContacts, isLoading } = useContactsQuery();

  const contacts = useMemo(() => {
    if (!fetchedContacts) {
      return [];
    }

    const reorderedContacts: Contact[] = [];
    let filteredContacts = fetchedContacts;

    props.contacts.forEach(({ value, isSelected }) => {
      const contactRecord = filteredContacts.find((c) => c.id === value);
      filteredContacts = filteredContacts.filter((c) => c.id !== value);

      if (contactRecord && isSelected) {
        reorderedContacts.push(contactRecord);
      }
    });

    return [...reorderedContacts, ...filteredContacts];
  }, [fetchedContacts, props.contacts]);

  if (isLoading) {
    return (
      <div style={{ display: 'block', width: '100%', height: '100vh' }}>
        <SkeletonLoader count={30} />
      </div>
    );
  }

  if (!contacts || contacts.length === 0) {
    return null;
  }

  return (
    <ul className="contacts-list">
      {contacts.map((contact) => (
        <li key={contact.id} className="contacts-list__item">
          <ContactListItem contact={contact} />
        </li>
      ))}
    </ul>
  );
}
